import { useState } from "react";
import styled from "styled-components";
import CustomModal from "../Generic/CustomModal";
import { lightThemeColors } from "../../assets/styles/colors";
import { PhoneInput } from "react-international-phone";
import "react-international-phone/style.css";
import { POST } from "../../api/API";
import { showSuccessNotification, showErrorNotification } from "../../helper/Notifications";
import { useProjectContext } from "../../context/useProjectContext";

const SalesModal = ({ setIsModalOpen }) => {
  const [phone, setPhone] = useState("");
  const [message, setMessage] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const { selectedProject } = useProjectContext();

  const handleSend = () => {
    setIsLoading(true);
    const payload = {
      phone_number: phone || "",
      message: message,
      type: "sales"
    };

    POST(
      `/api/v1/public_api/projects/${selectedProject?.id}/licensing/contact`,
      payload,
      () => {
        setIsLoading(false);
        setIsModalOpen(false);
        showSuccessNotification("Message sent successfully!");
      },
      (error) => {
        setIsLoading(false);
        console.error("Failed to send sales message:", error);
        showErrorNotification("Failed to send message. Please try again.");
      }
    );
  };

  return (
    <CustomModal
      isOpen={true}
      onOpenChange={(open) => !open && setIsModalOpen(false)}
      iconType="chip"
      iconAlignment="left"
      title="Talk to our Sales team"
      subtitle={
        <>
          Ready to unlock the full potential of our enterprise solution? Our sales team is here to understand your needs, walk you through our platform, and design a plan that works for your organization. For more info read our{" "}
          <FAQLink href="https://emotii.ai/faq" target="_blank" rel="noopener noreferrer">FAQ</FAQLink>.
        </>
      }
      buttons={[
        { text: "Cancel", variant: "secondary", onClick: () => setIsModalOpen(false) },
        { text: "Send message", variant: "primary", onClick: handleSend, disabled: message.trim().length === 0 || isLoading },
      ]}
    >
      <div className="flex flex-col gap-6 text-left">
        <div className="flex flex-col gap-1.5 w-full">
          <label className="font-inter text-sm font-medium leading-5 text-gray-700">Phone number</label>
          <StyledPhoneInput
            defaultCountry="us"
            value={phone}
            onChange={(phone) => setPhone(phone)}
            placeholder="+1 (555) 000-0000"
          />
        </div>

        <div className="flex flex-col gap-1.5 w-full">
          <label className="font-inter text-sm font-medium leading-5 text-gray-700">Message</label>
          <MessageTextArea
            placeholder="Share details about your organization, your goals, and how you plan to use emotii.ai."
            value={message}
            onChange={(e) => setMessage(e.target.value)}
            rows={5}
          />
        </div>
      </div>
    </CustomModal>
  );
};

export default SalesModal;

const FAQLink = styled.a`
  font-family: Lato;
  font-size: 16px;
  font-weight: 700;
  line-height: 24px;
  color: #7F56D9;
  text-decoration: underline !important;
`;

const StyledPhoneInput = styled(PhoneInput)`
  width: 100%;

  .react-international-phone-input-container {
    width: 100%;
  }

  .react-international-phone-input {
    flex: 1;
    width: 100%;
    border-radius: 0 8px 8px 0;
  }

  .react-international-phone-country-selector {
    border-radius: 8px 0 0 8px;
  }
`;

const MessageTextArea = styled.textarea`
  border: 1px solid ${lightThemeColors.sidebar.menuItemBorder};
  background: ${lightThemeColors.background};
  color: #717680;
  border-radius: 8px;
  padding: 10px 12px;
  font-family: Inter, sans-serif;
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  outline: none;
  resize: none;
  width: 100%;
`;
